// src/pages/auth/RegisterSuccessPage.jsx
import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import Navbar from '../../components/marketing/Navbar';

const RegisterSuccessPage = () => {
  const location = useLocation();
  const email = location.state?.email || '';

  return (
    <div className="min-h-screen bg-cream-100 font-['Lexend_Deca']">
      <Navbar />
      
      <div className="pt-24 pb-12 px-4">
        <div className="max-w-md mx-auto bg-white rounded-lg shadow-md p-8 mt-8 text-center">
          {/* Success Icon */}
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
          </div>

          <h1 className="text-3xl font-light text-purple-800 mb-4">
            Registratie Succesvol!
          </h1>

          <div className="bg-purple-50 border border-purple-200 rounded-lg p-4 mb-6">
            <p className="text-sm text-purple-900 mb-2">
              We hebben een verificatie e-mail gestuurd naar:
            </p>
            <p className="font-semibold text-purple-800">
              {email}
            </p>
          </div>

          <div className="text-left space-y-4 mb-6">
            <h2 className="font-semibold text-gray-800 text-center mb-3">Volgende stappen:</h2>
            
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0 w-6 h-6 bg-purple-500 text-white rounded-full flex items-center justify-center text-sm font-semibold">
                1
              </div>
              <div>
                <p className="text-gray-700">
                  <strong>Check je inbox</strong> - Zoek naar een e-mail van LerenMotiveren
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0 w-6 h-6 bg-purple-500 text-white rounded-full flex items-center justify-center text-sm font-semibold">
                2
              </div>
              <div>
                <p className="text-gray-700">
                  <strong>Klik op de verificatielink</strong> - Dit bevestigt je e-mailadres
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0 w-6 h-6 bg-purple-500 text-white rounded-full flex items-center justify-center text-sm font-semibold">
                3
              </div>
              <div>
                <p className="text-gray-700">
                  <strong>Begin met leren</strong> - Je wordt doorgestuurd naar de training
                </p>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 text-sm text-gray-600">
            <p className="font-medium mb-1">Geen e-mail ontvangen?</p>
            <p>
              Check je spam/ongewenste e-mail map. Als je nog steeds niets hebt ontvangen na 5 minuten, neem dan contact met ons op.
            </p>
          </div>

          <div className="mt-6">
            <Link
              to="/"
              className="text-purple-600 hover:text-purple-800 font-medium"
            >
              ← Terug naar home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterSuccessPage;